import styled from "styled-components";

export const SuccessMessagePage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  width: 100vw;
  height: 100vh;

  background: ${(props) => props.theme.colors["black-900"]};

  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    padding: 0 1.5rem;
  }
`;

export const SuccessMessageText = styled.p`
  color: ${(props) => props.theme.colors["white"]};
  text-align: center;
  margin-top: 2rem;
  margin-bottom: 1rem;
`;

export const SuccessMessageContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
  min-width: 300px;
`;
